//DrawControl utiliza a bibliote L.Draw do leaflet para construir formas geométricas customizadas no mapa
//Observação. Esse componente disponibiliza as formas geométricas para desenho no mapa, e quando desenhadas, acidiona no featureGroup informado como parametro
    //Entretanto, o que essa forma deve fazer (se tiver que fazer algo) deve ser feito através de listeners como $(map).on(draw:drawstop) (eventos que são disparados de forma nativa pela biblioteca L.Draw)
/**
 * 
 * @param {LeafletMap} map mapa leaflet
 * @param {Hash} options 
 *  required: String container: onde ficara a toolbar com as opções de formas
 *  required: featureGroup feature_group: camada onde as formas geométricas serão criadas
 */

export default function DrawControl(map, options){
    let container = options.container
    let title = options.title || undefined
    let elements = {
        container:undefined, 
        title:undefined,
        controls_container:undefined,
        controls:{}
    }
    let available_controls = {
        'polygon': {icon:'<i data-name="polygon" class="fas fa-draw-polygon"></i>'},
        'square': {icon:'<i data-name="square" class="fas fa-vector-square"></i>'},
        'circle': {icon: '<i data-name="circle" class="far fa-circle"></i>'}
    }
    let drawControl = new L.Control.Draw({
        edit: {
            featureGroup: options.feature_group
        }
    });

    let state = {
        draw:{
            drawing: false,
            who: undefined
        }
        
    }
    this.generate = () =>{
        //gerando containers
        generateContainers()
        
        //gerando titulo caso informado
        if(title){
            generateTitle()
        }

        //'localizando' os toolpis do LeafletDraw
        setTooltips()

        //gerando botoões de controle das formas
        generateControls()

        //adicionando tudo no container informado via parametro
        $(container).html(elements.container)

        //adicionando handler de eventos
        eventsHandler()
        
    }

    function setTooltips(){
        let handlers = L.drawLocal.draw.handlers
        handlers.circle.radius = "Raio"
        handlers.circle.tooltip.start = "Clique e arraste para desenhar o círculo"
        handlers.simpleshape.tooltip.end = "Solte para terminar o desenho"
        handlers.rectangle.tooltip.start = "Clique e arraste para desenhar o retângulo"
        handlers.polygon.tooltip.start = "Clique para começar a desenhar a figura"
        handlers.polygon.tooltip.cont = "Clique para continuar a desenhar a figura"
        handlers.polygon.tooltip.end = "Clique no primeiro ponto para fechar esta figura"
    }

    function generateContainers(){
        //container principal
        elements.container = document.createElement('div')
        elements.container.classList.add('draw-control-container')

        //container title
        if(title){
            elements.title = document.createElement('div')
            elements.title.classList.add('draw-control-title')
            elements.container.appendChild(elements.title)
        }
        //container buttons
        elements.controls_container = document.createElement('div')
        elements.controls_container.classList.add('draw-control-items')
        elements.container.appendChild(elements.controls_container)  
    }

    function generateControls(){
        $.each(available_controls, (name,control)=>{
            //instanciando
            let button = new Button({icon: control.icon, name:name, container:elements.controls_container})
            //gerando Button (será acoplado no fim da div de container)
            button.generate()
            
            //adicionando instancia do button na lista de botões
            elements.controls[name] = button
        })
    }

    function generateTitle(){
        let element = document.createElement('div')
        element.innerHTML = title
        elements.title.appendChild(element)
    }

    function eventsHandler(){
        //evento disparado ao clicar em qualquer botao de criação de forma
        $(document).on('draw_control_button:click', (e,data)=>{
            //desativando qualquer atual
            if(state.draw.who != undefined){
                elements.controls[state.draw.who].disable()
            }
            //informando novo atual/limpando atual
            if(data.state){
                state.draw.who = data.name
                state.draw.drawing = true
            } else {
                state.draw.who = undefined
                state.draw.drawing = false
            }
        })
        //evento disparado ao terminar de desenhar/cancelar o desenho de uma forma
        map.on('draw:drawstop', function(e){
            //caso tenha atual, desabilitando
            if(state.draw.who != undefined){
                elements.controls[state.draw.who].disable()
                state.draw.who = undefined
                state.draw.drawing = false
            }
        })
    }

    /**
     * Instancia de botão para o DrawControl. Possui métodos para ajudar no controle de ativação/desativação do mesmo.
     * Dispara eventos de click para o 'document', q é usado pelo DrawControl e pode ser usado fora por qualquer motivo
     * @param {Hash} options 
     */
    function Button(options){
        let icon = options.icon
        let name = options.name
        let container = options.container
        let button = undefined
        let drawHandler = definedDrawHandler(options.name)
        let state = {
            active: false
        }
        this.generate = () =>{
            //criando container
            let element = document.createElement('div')
            element.classList.add('draw-control-item')
            element.dataset.name = name
            //adicionando icon
            element.innerHTML = options.icon
            //salvando o elemento em uma variavel para acesso posterior
            button = element
            //acoplando no container parametrizado
            $(container).append(element)
            //adicionando handler de eventos
            handlerEvents.call(this)
        }
        //retorna o elemento do botão
        this.getButton = () =>{
            return button
        }
        //ativando/desativando o botão (apenas estilo)
        this.active = (boolean) =>{
            $(button).toggleClass('active', boolean)
        }
        //desabilitando botão (estilo,status e drawHandler)
        this.disable = () =>{
            this.active(false)
            drawHandler.disable()
            state.active = false
        }

        //events handler
        function handlerEvents(){
            $(button).on('click', ()=>{
                this.active(!state.active)
                state.active = !state.active
                
                if(state.active){
                    drawHandler.enable()
                } else {
                    drawHandler.disable()
                }
                $(document).trigger('draw_control_button:click',{name:name, state: state.active})
            })
        }

        //define o L.Draw do botão baseado no nome dele. Ex: (name = 'polygon', drawHandler = L.Draw.Polygon)
        function definedDrawHandler(name){
            switch(name){
                case "polygon":
                    return new L.Draw.Polygon(map, drawControl.options.polygon)
                case "square":
                    return new L.Draw.Rectangle(map, drawControl.options.rectangle)
                case "circle":
                    return new L.Draw.Circle(map, drawControl.options.circle)
                default:
                    return new L.Draw.Circle(map, drawControl.options.circle)
            }

        }
    }
}